import { defineNuxtPlugin, useRouter } from '#imports'
import { useAmazonState } from '~/composables/useAmazonState'

export default defineNuxtPlugin(() => {
  const router = useRouter()
  const { checkIsAmazon } = useAmazonState()

  // Add a route change handler to check for Amazon state on each route change
  router.afterEach(() => {
    checkIsAmazon()
  })
})
